import MemberRepo from '../../../Repo/MemberRepo'
import React from 'react'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import {FanClubLinkListContentBlock} from './Components/FanClubLinkListContentBlock'
import {useAsync} from 'react-use'
import {MBMemberError} from '../../../Common/MBMemberError'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {PageUrlInfo} from '../../../Models/Types'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMPrimaryButton} from '../../Atoms/Buttons/Bases/PIMPrimaryButton'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {checkAsyncStateAndGetData, memberResponseStatusCheck} from '../../../Utils/MemberResponseStatusCheck'
import {useTranslation} from 'react-i18next'

export type MembersAccountTopPageProps = {
  navigator: NavigatorForMemberPage
  memberRepo: MemberRepo
}

export const MembersAccountTopPage: React.VFC<MembersAccountTopPageProps> = (
  {
    navigator,
    memberRepo,
  },
) => {
  const {t} = useTranslation('member')

  const getSelfResult = useAsync(async () => {
    return await memberRepo.getSelf()
  })

  const getSignedUpSignboardsResult = useAsync(async () =>
    await memberRepo.getSignedUpBucketInfoList())

  if (getSelfResult.loading) {
    return null
  }

  if (getSelfResult.error) {
    throw new MBMemberError(getSelfResult.error.message)
  }

  if (!getSelfResult.value) {
    throw new MBMemberError('UnknownError')
  }

  memberResponseStatusCheck(getSelfResult.value.status)

  if (getSignedUpSignboardsResult.loading) {
    return null
  }

  if (getSignedUpSignboardsResult.error) {
    throw new MBMemberError(getSignedUpSignboardsResult.error.message)
  }

  if (!getSignedUpSignboardsResult.value) {
    throw new MBMemberError('UnknownError')
  }

  memberResponseStatusCheck(getSignedUpSignboardsResult.value.status)

  function goToAccountInformationPage(): void {
    navigator.goToAccountInformationPage()
  }

  const {member} = getSelfResult.value.data
  const allSignboards = checkAsyncStateAndGetData(getSignedUpSignboardsResult)
  const signedUpSignboards = allSignboards.filter(signboard => signboard.signedUp)
  const notSignedUpSignboards = allSignboards.filter(signboard => !signboard.signedUp)

  const enteredSignboardPageUrlInfoList: PageUrlInfo[] = signedUpSignboards.map((item) => {
    return {
      url: item.bucketTopPageInfo.url,
      name: item.bucketName,
      signedUpStates: item.signedUpStates,
    }
  })
  const noEnteredSignboardPageUrlInfoList: PageUrlInfo[] = notSignedUpSignboards.map((item) => {
    return {
      url: item.bucketGuidancePageUrl,
      name: item.bucketName,
      signedUpStates: item.signedUpStates,
    }
  })

  return (
    <MembersPageTemplate>
      <PageTitle>{t('MYアカウント.ページ名')}</PageTitle>
      <ContentBlock data-testid={'block-member-info'}>
        <div className="table_02 mb0">
          <table>
            <colgroup>
              <col className="w_20"/>
              <col className="w_80"/>
            </colgroup>
            <tbody>
            <tr>
              <th>{`${t('MYアカウント.会員基本情報テーブル.テーブルヘッダー 名前')}`}</th>
              <td>
                <div className="form-textgroup">
                  {`${member?.familyName} ${member?.firstName}`}&nbsp;
                </div>
              </td>
            </tr>
            <tr>
              <th>{`${t('MYアカウント.会員基本情報テーブル.テーブルヘッダー メールアドレス')}`}</th>
              <td>
                <div className="form-textgroup">
                  {member?.mail}&nbsp;
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Spacer mt={'25px'}>
          <PIMPageActions>
            <PIMPrimaryButton onClick={goToAccountInformationPage}>
              {`${t('MYアカウント.会員基本情報テーブル.ボタン 会員基本情報変更')}`}
            </PIMPrimaryButton>
          </PIMPageActions>
        </Spacer>
      </ContentBlock>

      <FanClubLinkListContentBlock
        title={t('MYアカウント.入会済みバケットリスト.タイトル')}
        pageUrlInfoList={enteredSignboardPageUrlInfoList}
        noSignboardListMessage={t('MYアカウント.入会済みバケットリスト.メッセージ 入会済みバケットなし')}
        testId={'block-entered-fan-club'}
      />
      {noEnteredSignboardPageUrlInfoList.length > 0 && <FanClubLinkListContentBlock
          title={t('MYアカウント.未入会バケットリスト.タイトル')}
          pageUrlInfoList={noEnteredSignboardPageUrlInfoList}
          noSignboardListMessage={''}
          testId={'block-no-entered-fan-club'}
      />}
    </MembersPageTemplate>
  )
}
